import { createId, getGbStringLength, deepClone, debounce, debounceCall, throttle, throttleCall, withRetry, copy, findLastIndex } from '@/utils/index'
// import store from '@/store'
import excelUtil from "@/utils/excelUtil";
import { getBrowserKey } from "@/utils/browserUtil";
import { ImagePreview } from 'vant';

//#region 临时公共方法
// /**
//  * Use meta.role to determine if the current user has permission
//  * @param roles
//  * @param route
//  */
// function hasPermission(permission) {
//     let hasPermission = false;
//     const permissions = store.getters.permission
//     for (let i = 0; i < permissions.length; i++) {
//         if (permissions[i].permission === permission) {
//             hasPermission = true;
//             break;
//         }
//     }
//     return hasPermission
// }
//初始化弹窗参数
function initDialogOpt(title, msg) {
    let opt = {
        title: title,
        message: msg
    };
    title = title || "出错了";
    if (!msg) {
        if (typeof (title) == "object") {
            if(title instanceof Error){
                title = { message: title.message || "服务出错"};
            }
            if (!title.message && title.msg) {
                title.message = title.msg;
            }
            opt = title.message ? title : { message: title };
        } else {
            opt = {
                message: title
            };
        }
    }
    if (getGbStringLength(opt.message) > 38) {
        opt.messageAlign = "left";
    }
    return opt;
}
//#endregion

export default {
    install(Vue) {
        //扩展全局函数
        Object.defineProperty(Vue.prototype, '$self', {
            get: function() {
              return this;
            },
            configurable: false, // 可配置性
            enumerable: false // 可枚举性
        });

        //#region 全局公共方法和挂载
        //全局事件总线
        Vue.prototype.$bus = new Vue();

        //验证权限
        //Vue.prototype.hasPermission = hasPermission;

        //深复制
        Vue.prototype.deepClone = deepClone;
        Vue.prototype.debounce = debounce;
        Vue.prototype.debounceCall = debounceCall;
        Vue.prototype.throttle = throttle;
        Vue.prototype.throttleCall = throttleCall;
        Vue.prototype.withRetry = withRetry;
        Vue.prototype.copy = copy;
        Vue.prototype.findLastIndex = findLastIndex;
        //获取浏览器key异步方法
        Vue.prototype.getBrowserKey = getBrowserKey;
        //创建ID
        Vue.prototype.createId = createId;
        //缓存Id
        Vue.prototype.getCacheId = function (key) {
            key = key || "";
            let cacheKey = 'GBLCacheId' + key,
                cacheId = this.$cache.get(cacheKey);
            if (cacheId) {
                return cacheId;
            }
            cacheId = this.createId(6);
            this.$cache.set(cacheKey, cacheId);
            return cacheId;
        };
        //刷新缓存Id
        Vue.prototype.delCacheId = function (key) {
            key = key || "";
            let cacheKey = 'GBLCacheId' + key;
            this.$cache.remove(cacheKey);
        };

        //#endregion

        //#region 弹框消息处理
        //错误信息
        function toMsg(opt) {
            if (!opt) {
                return "";
            }
            opt = opt.message || opt.msg || opt.desc || opt;
            if (typeof (opt) == "object") {
                opt = JSON.stringify(opt);
            }
            return opt;
        }
        Vue.prototype.toMsg = toMsg;

        //有确定按钮的提示，如果不要确定按钮请用this.$toast("请选择优惠券");
        Vue.prototype.$toast.allowMultiple();
        Vue.prototype.$showMsg = (title, msg) => {
            let opt = initDialogOpt(title, msg);
            return Vue.prototype.$dialog.alert(opt);
        };
        Vue.prototype.$confirm = (title, msg) => {
            let opt = initDialogOpt(title, msg);
            return Vue.prototype.$dialog.confirm(opt)
        };
        Vue.prototype.$msg = opt => {
            if (opt && opt instanceof Error) {
                return Vue.prototype.$toast.fail({ message: opt.message || opt.msg || "出错了" })
            }
            if (opt === "cancel") {
                return false;
            }
            return Vue.prototype.$toast(opt)
        };
        Vue.prototype.$msg.fail = Vue.prototype.$msg.error = msg => {
            if (msg === "cancel") {
                return false;
            }
            if (msg && msg instanceof Error) {
                return Vue.prototype.$toast.fail({ message: msg.message || msg.msg || "出错了" })
            }
            return Vue.prototype.$toast.fail(msg)
        };
        Vue.prototype.$msg.success = msg => {
            return Vue.prototype.$toast.success(msg)
        };
        Vue.prototype.$message = Vue.prototype.$message || Vue.prototype.$msg;
        Vue.prototype.$message.errorFun = Vue.prototype.$message.error || Vue.prototype.$msg.error;
        Vue.prototype.$message.fail = Vue.prototype.$message.error = opt => {
            if (opt && opt instanceof Error) {
                return Vue.prototype.$message.errorFun(opt.message || "出错了");
            }
            if (opt === "cancel") {
                return false;
            }
            return Vue.prototype.$message.errorFun(opt);
        };
        Vue.prototype.$loadingFun = Vue.prototype.$loading;
        Vue.prototype.$loading = opt => {
            if (!opt) {
                opt = "提交中..."
            }
            if (typeof (opt) === "string") {
                opt = { message: opt };
            }
            return Vue.prototype.$toast.loading(Object.assign({
                message: '提交中...',
                forbidClick: true,
                overlay: true,
                duration: 60000,
            }, opt));
        };
        Vue.prototype.$loading2 = opt => {
            if (!opt) {
                opt = "提交中..."
            }
            if (typeof (opt) === "string") {
                opt = { text: opt };
            }
            return Vue.prototype.$loadingFun(Object.assign({
                lock: true,
                text: '"提交中...',
                fullscreen: true,
                lock: true,
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            }, opt));
        };

        //通知
        Vue.prototype.$notifyFun = Vue.prototype.$notify;
        Vue.prototype.$notify = function (title, message, clickFun, type, duration) {
            var opt = {
                title: title,
                message: message
            };
            if (!message) {
                opt.title = "";
                opt.message = title;
            }
            if (clickFun) {
                opt.onClick = clickFun;
            }
            if (type) {
                opt.type = type;
            }
            if (typeof (duration) !== "undefined") {
                opt.duration = duration;
            }
            return Vue.prototype.$notifyFun(opt);
        };
        Vue.prototype.$notify.success = function (title, message, clickFun, duration) {
            return Vue.prototype.$notify(title, message, clickFun, "success", duration);
        };
        Vue.prototype.$notify.fail = Vue.prototype.$notify.error = function (title, message, clickFun, duration) {
            return Vue.prototype.$notify(title, message, clickFun, "error", duration);
        };
        Vue.prototype.$notify.info = function (title, message, clickFun, duration) {
            return Vue.prototype.$notify(title, message, clickFun, "info", duration);
        };
        Vue.prototype.$notify.warning = function (title, message, clickFun, duration) {
            return Vue.prototype.$notify(title, message, clickFun, "warning", duration);
        };
        //#endregion

        //#region ------路由
        Vue.prototype.goPage = function (path, query) {
            if (typeof (path) == "object") {
                this.$router.push(path);
            } else {
                this.$router.push({
                    path: path,
                    query: query || {}
                });
            }
        };
        Vue.prototype.replacePage = function (path, query) {
            if (typeof (path) == "object") {
                this.$router.replace(path);
            } else {
                this.$router.replace({
                    path: path,
                    query: query || {}
                });
            }
        };
        Vue.prototype.goBack = function () {
            this.$router.back();
        };
        Vue.prototype.go = function (n) {
            if (typeof (n) == "undefined") {
                n = 1;
            }
            this.$router.go(-n);
        };
        //#endregion

        //#region -----组件相关
        Vue.prototype.getName = function () {
            let that = this || {}
            return (that.$options || that.$route || {}).name || "";
        };
        Vue.prototype.getPageKey = function (key) {
            let that = this || {}
            return ((that.$options || that.$route || {}).name || "page_") + (key || "");
        };
        //图片预览
        Vue.prototype.showImg = function (imgUrl) {
            if (!imgUrl) {
                return;
            }
            if (!Array.isArray(imgUrl)) {
                imgUrl = [imgUrl];
            }
            if (imgUrl.length == 0) {
                return;
            }
            var that = this;
            var showImgComp = ImagePreview({
                images: imgUrl,
                onClose() {
                    that.delBackEvent("showImg");
                    showImgComp = null;
                },
                closeable: true,
                closeOnPopstate: true,
            });
            that.addOneBackEvent(() => {
                showImgComp && showImgComp.close();
                return Promise.reject(false);
            }, "showImg");
        };
        //#endregion

        //#region -----表单相关
        Vue.prototype.verifyForm = function (formName) {
            let that = this || {};
            return new Promise((done, fail) => {
                if (!(that.$refs && that.$refs[formName] && that.$refs[formName].validate)) {
                    return fail("未找到对应表单");
                }
                that.$refs[formName].validate(function (valid, curRules) {
                    if (!valid) {
                        curRules = curRules || {};
                        var key = Object.keys(curRules)[0] || "";
                        var msg = ((curRules[key] || {})[0] || {}).message || "尚有必填字段未填";
                        return fail(msg);
                    }
                    return done();
                });
            });
        };
        //#endregion

        //#region -----事件相关
        Vue.prototype.XyjEvent = {
            enter: {
                key: 'enter'
            },
            back: {
                key: 'back'
            }
        };
        //////----通过返回Promise.reject来阻止事件继续触发
        //////----通过callXyjEvent来获取所有事件的执行结果Promise，都成功时的then返回值数组，失败时返回失败事件的Promise.reject
        /////------------供父组件调用：返回true,表示已关闭所有弹窗可以回退，返回false,表示不可回退，需要关闭弹窗
        ////----resultFalseOrErrorIsStopEvent:返回值如果是False或者Error是否阻止事件函数继续执行，默认否
        ////----isLastRun:最否在函数后面执行，默认否
        Vue.prototype.addXyjEvent = function (eventName, fun, key, resultFalseOrErrorIsStopEvent, isLastRun) {
            var vueBase = Vue.prototype, that = this || vueBase;
            return that.getXyjEvent(eventName).$on(fun, key, resultFalseOrErrorIsStopEvent, isLastRun);
        };
        Vue.prototype.addOneXyjEvent = function (eventName, fun, key, resultFalseOrErrorIsStopEvent, isLastRun) {
            var vueBase = Vue.prototype, that = this || vueBase;
            return that.getXyjEvent(eventName).$once(fun, key, resultFalseOrErrorIsStopEvent, isLastRun);
        };
        Vue.prototype.delXyjEvent = function (eventName, key) {
            var vueBase = Vue.prototype, that = this || vueBase;
            return that.getXyjEvent(eventName).$off(key);
        };
        Vue.prototype.callXyjEvent = function (eventName) {
            var vueBase = Vue.prototype, that = this || vueBase;
            let eventObj = that.getXyjEvent(eventName), args = Array.prototype.slice.call(arguments, 1);
            return eventObj.$emit.apply(eventObj, args);
        };
        ////----初始化事件
        ////----eventName:事件名
        ////----isGlobal:是否为全局事件
        Vue.prototype.getXyjEvent = function (eventName, isGlobal) {
            var vueBase = Vue.prototype,
                that = this || vueBase,
                global = null,
                eventHaddle = null;
            if (isGlobal) {
                global = vueBase;
                if (!global.$xyjGlobalEventHaddle) {
                    global.$xyjGlobalEventHaddle = {};
                }
                eventHaddle = global.$xyjGlobalEventHaddle;
            } else {
				global = that.$self || that;
                if (!global.$xyjEventHaddle) {
                    global.$xyjEventHaddle = {};
                }
                eventHaddle = global.$xyjEventHaddle;
            }
            eventName = eventName || that.getName() || vueBase.createId(8);
            var curEventConfig = eventHaddle[eventName], eventObj = null;
            if (!curEventConfig) {
                curEventConfig = eventHaddle[eventName] = {
                    obj: {},
                    argsObj: {},
                    list: [],
                    lastRunList: [],
                    haddle: function () {
                        var args = arguments;
                        return Promise.reduceThenByArray((curEventConfig.list.concat(curEventConfig.lastRunList)).map(key => {
                            var fun = curEventConfig.obj[key];
                            if (!fun) {
                                return null;
                            }
                            var curArgsObj = curEventConfig.argsObj[key] || {};
                            if (curArgsObj.type == 'once') {
                                offEvent(key);
                            }
                            return () => {
                                try {
                                    var result = fun.apply(that, args);
                                    if (curArgsObj.resultFalseOrErrorIsStopEvent) {
                                        if (!result) {
                                            return Promise.reject(result);
                                        }
                                        if (result instanceof Error) {
                                            return Promise.reject(result);
                                        }
                                    }
                                    return result;
                                } catch (e) {
                                    return Promise.reject(e);
                                }
                            };
                        }).filter(s => s));
                    },
                };
                that.$on(eventName, curEventConfig.haddle);
            }
            var offEvent = function (key) {
                if (curEventConfig && curEventConfig.obj) {
                    if (key) {
                        if (curEventConfig.obj[key]) {
                            delete curEventConfig.obj[key];
                            delete curEventConfig.argsObj[key];
                            var index = curEventConfig.list.indexOf(key);
                            if (index > -1) {
                                curEventConfig.list.splice(index, 1);
                            }
                            var lastIndex = curEventConfig.lastRunList.indexOf(key);
                            if (lastIndex > -1) {
                                curEventConfig.lastRunList.splice(lastIndex, 1);
                            }
                        }
                    } else {
                        curEventConfig.obj = {};
                        curEventConfig.argsObj = {};
                        curEventConfig.list.splice(0);
                        curEventConfig.lastRunList.splice(0);
                    }
                }
                return eventObj;
            },
                addEvent = function (type, fun, key, resultFalseOrErrorIsStopEvent, isLastRun) {
                    key = key || vueBase.createId(8);
                    curEventConfig.obj[key] = fun || (() => { });
                    curEventConfig.argsObj[key] = { type, resultFalseOrErrorIsStopEvent };
                    if (isLastRun) {
                        curEventConfig.lastRunList.push(key);
                    } else {
                        curEventConfig.list.push(key);
                    }
                    return eventObj;
                };

            eventObj = {
                ////----resultFalseOrErrorIsStopEvent:返回值如果是False或者Error是否阻止事件函数继续执行，默认否
                ////----isLastRun:最否在函数后面执行，默认否
                $on: addEvent.bind(null, 'on'),
                $once: addEvent.bind(null, 'once'),
                $off: offEvent,
                $emit: curEventConfig.haddle,
                $init: () => eventObj,
            };
            return eventObj;
        };
        ////----生成特定事件调用函数
        Vue.prototype.createXyjEventFun = function (eventName, isGlobal, callFunName) {
            return function () {
                var vueBase = Vue.prototype, that = this || vueBase;
                let eventObj = that.getXyjEvent(eventName, isGlobal);
                if (eventObj[callFunName]) {
                    return eventObj[callFunName].apply(eventObj, arguments);
                }
                return new Error('callFunName:' + callFunName + ' is not exist');
            };
        };

        //////------回车事件相关
        //Vue.prototype.addEnterEvent = function(fun,name) {
        //    var vueBase = Vue.prototype, that = this || vueBase;
        //    return that.getXyjEvent(vueBase.XyjEvent.enter.key, true).$on(fun,name);
        //};
        //Vue.prototype.delEnterEvent = function(name) {
        //    var vueBase = Vue.prototype, that = this || vueBase;
        //    return that.getXyjEvent(vueBase.XyjEvent.enter.key, true).$off(name);
        //};
        Vue.prototype.addEnterEvent = Vue.prototype.createXyjEventFun(Vue.prototype.XyjEvent.enter.key, true, '$on');
        Vue.prototype.delEnterEvent = Vue.prototype.createXyjEventFun(Vue.prototype.XyjEvent.enter.key, true, '$off');
        //需在app.vue中初始化
        Vue.prototype.enterEventInit = function () {
            var vueBase = Vue.prototype, that = this || vueBase;
            var eventObj = that.getXyjEvent(vueBase.XyjEvent.enter.key, true);

            document.onkeydown = e => {
                //let body = document.getElementsByTagName('body')[0]
                //if (body && e.target === body) {
                    //e.target.baseURI.match(/inputbook/) match(此处应填写文件在浏览器中的地址，如 '/home/index')，不写的话，其他页面也会有调用回车按下的方法
                    const { key, keyCode } = e;
                    if (key !== undefined && key === 'Enter') {
                        eventObj.$emit(e);
                    } else if (keyCode !== undefined && keyCode === 13) {
                        eventObj.$emit(e);
                    }
                //}
            }
        };

        //////----回退事件
        //Vue.prototype.callBackEvent = function () {
        //    var vueBase = Vue.prototype, that = this || vueBase;
        //    let eventObj = that.getXyjEvent(vueBase.XyjEvent.back.key, false);
        //    return eventObj.$emit.apply(eventObj,arguments);
        //};
        Vue.prototype.addBackEvent = Vue.prototype.createXyjEventFun(Vue.prototype.XyjEvent.back.key, false, '$on');
        Vue.prototype.addOneBackEvent = Vue.prototype.createXyjEventFun(Vue.prototype.XyjEvent.back.key, false, '$once');
        Vue.prototype.delBackEvent = Vue.prototype.createXyjEventFun(Vue.prototype.XyjEvent.back.key, false, '$off');
        Vue.prototype.callBackEvent = Vue.prototype.createXyjEventFun(Vue.prototype.XyjEvent.back.key, false, '$emit');

        //#endregion

        //#region -----获取组件容器
        // Vue.prototype.getContainer = function (domName) {
        //     domName = domName || "#app";
        //     var container;
        //     if (typeof (domName) == "string") {
        //         container = document.querySelector(domName);
        //     } else if (typeof (domName) == "object") {
        //         container = domName;
        //     } else if (typeof (domName) == "function") {
        //         container = domName();
        //     }
        //     if (!container) {
        //         container = document.querySelector("#app");
        //         if (!container) {
        //             container = document.querySelector("body");
        //         }
        //     }
        //     return container;
        // };
        // ////-----动态创建组件（经测下面两种均可，第二种容错好些，第一种容易报错）
        // //Component:组件对象
        // //props:组件属性
        // //eventObj:组件侦听事件（on绑定的事件）
        // //isHideBody:是否隐藏body(默认否)
        // //domName:容器dom(默认#app)
        // Vue.prototype.createComponent2 = function (Component, props, eventObj, isHideBody, domName) {
        //     var that = this || Vue.prototype, container = that.getContainer(domName);
        //     const comp = new (Vue.extend(Component))({ propsData: props, _parentListeners: (eventObj || {}) }).$mount();
        //     var id = that.createId(8);
        //     that.addBackEvent(function () {
        //         return comp.callBackEvent().then(() => {
        //             comp && comp.$remove && comp.$remove();
        //         });
        //     }, id, false, true);
        //     if (isHideBody && that.$store && that.$store.dispatch) {
        //         that.$store.dispatch('app/hideBody');
        //     }
        //     comp.$store = that.$store;
        //     container.appendChild(comp.$el);
        //     comp.$remove = () => {
        //         that.delBackEvent(id);
        //         if (isHideBody && that.$store && that.$store.dispatch) {
        //             that.$store.dispatch('app/showBody');
        //         }
        //         comp.$el.remove();
        //         //container.removeChild(comp.$el)
        //         comp.$destroy()
        //     }
        //     return comp;
        // };
        // Vue.prototype.createComponent = function (Component, props, eventObj, isHideBody, domName) {
        //     var that = this || Vue.prototype, container = that.getContainer(domName);
        //     // 借鸡生蛋new Vue({render() {}}),在render中把Component作为根组件
        //     const vm = new Vue({
        //         store,
        //         // h是createElement函数，它可以返回虚拟dom
        //         render(h) {
        //             //console.log(h(Component,{ props }));

        //             // 将Component作为根组件渲染出来
        //             // h(标签名称或组件配置对象，传递属性、事件等，孩子元素)
        //             return h(Component, { props, on: (eventObj || {}) })
        //         }
        //     }).$mount() // 挂载是为了把虚拟dom变成真实dom
        //     // 不挂载就没有真实dom
        //     // 手动追加至body
        //     // 挂载之后$el可以访问到真实dom
        //     var id = that.createId(8);
        //     that.addBackEvent(function () {
        //         return comp.callBackEvent().then(() => {
        //             //return Promise.reject("组件未释放");
        //             comp && comp.$remove && comp.$remove();
        //         });
        //     }, id, false, true);
        //     if (isHideBody && that.$store && that.$store.dispatch) {
        //         that.$store.dispatch('app/hideBody');
        //     }
        //     //vm.$store = that.$store;
        //     container.appendChild(vm.$el)
        //     //console.log(vm.$children);

        //     // 实例
        //     const comp = vm.$children[0];
        //     //comp.$store = vm.$store;

        //     // 淘汰机制
        //     comp.$remove = () => {
        //         // 删除dom
        //         that.delBackEvent(id);
        //         if (isHideBody && that.$store && that.$store.dispatch) {
        //             that.$store.dispatch('app/showBody');
        //         }
        //         vm.$el.remove();
        //         //container.removeChild(vm.$el)

        //         // 销毁组件
        //         vm.$destroy()
        //     }

        //     // 返回Component组件实例
        //     return comp
        // };

        // ////-----组件挂载
        // //isHideBody:是否在挂载完成后隐藏body
        // //domEl:挂载元素
        // //domName:要挂载的容器标识(例：body,#app,默认：#app)或获取容器的函数
        // Vue.prototype.appendToContainer = function (isHideBody, domEl, domName) {
        //     var that = this || Vue.prototype, container = that.getContainer(domName);
        //     (that.$nextTick || Vue.prototype.$nextTick)(() => {
        //         domEl = domEl || that.$el;
        //         if (container.append) {
        //             container.append(domEl);
        //         } else {
        //             container.appendChild(domEl);
        //         }
        //         if (isHideBody) {
        //             that.$store.dispatch('app/hideBody');
        //         }
        //     });
        // };
        // //删除挂载的内容
        // //isShowBody:是否在挂载完成后显示body
        // //domEl:挂载元素
        // Vue.prototype.removeContainerChild = function (isShowBody, domEl, domName) {
        //     var that = this || Vue.prototype, container = that.getContainer(domName);
        //     (that.$nextTick || Vue.prototype.$nextTick)(() => {
        //         domEl = domEl || that.$el;
        //         if (container && domEl.remove) {
        //             domEl.remove();
        //             //container.removeChild(domEl);
        //             if (isShowBody) {
        //                 that.$store.dispatch('app/showBody');
        //             }
        //         }
        //     });
        // };
        //#endregion

        //#region -----浏览器滚动条相关
        //获取浏览器滚动条高度
        Vue.prototype.getScrollTop = function () {
            return document.body.scrollTop || (document.documentElement || {}).scrollTop || window.pageYOffset || 0;
        };
        //在缓存中记录浏览器滚动条高度
        Vue.prototype.addScrollTopLog = function (key) {
            if (!key) {
                key = this.getPageKey("_pagetop");
            }
            var that = Vue.prototype, top = that.getScrollTop();
            that.$cache(key, top);
            console.log("记录浏览器滚动条高度：", key, "=>", top);
        };
        //设置浏览器滚动条高度
        Vue.prototype.setScroll = (left, top) => {
            if (typeof window.scrollTo === 'function') {
                window.scrollTo(left, top);
            } else if (typeof (document.documentElement || {}).scrollTop === 'number' && typeof (document.documentElement || {}).scrollLeft === 'number') {
                document.documentElement.scrollTop = top;
                document.documentElement.scrollLeft = left;
            } else {
                document.body.scrollTop = top;
                document.body.scrollLeft = left;
            }
        };
        Vue.prototype.setScrollTop = top => {
            if (typeof window.scrollTo === 'function') {
                window.scrollTo(0, top);
            } else if (typeof document.documentElement.scrollTop === 'number') {
                document.documentElement.scrollTop = top;
            } else {
                document.body.scrollTop = top;
            }
        };
        //异步设置浏览器滚动条高度 -- （在Vue中数据变了并不会重新渲染，$nextTick在下一次渲染后执行）有的时候需要窗体展示以后再设置滚动条高度
        Vue.prototype.setScrollTopAsync = top => {
            var that = Vue.prototype;
            Vue.prototype.$nextTick(that.setScrollTop.bind(that, top));
        };
        //根据缓存记录----异步设置浏览器滚动条高度
        Vue.prototype.setScrollTopAsyncByLog = function (key) {
            if (!key) {
                key = this.getPageKey("_pagetop");
            }
            var that = Vue.prototype, top = that.$cache(key) || 0;
            that.setScrollTopAsync(top);
        };
        //#endregion

        //#region ------Promise相关
        Promise.isPromise = function (obj) {
            return obj && Object.prototype.toString.call(obj) === '[object Promise]'
            //return !!obj  //有实际含义的变量才执行方法，变量null，undefined和''空串都为false
            //    && (typeof obj === 'object' || typeof obj === 'function') // 初始promise 或 promise.then返回的
            //    && typeof obj.then === 'function';
        };
        //获取Promise状态
        const PROMISE_STATE = {
            PENDING: 'pending',
            FULFILLED: 'fulfilled',
            REJECTED: 'rejected'
        };
        Promise.prototype.PROMISE_STATE = PROMISE_STATE;
        //返回异步函数，在then中获取状态
        Promise.getStatus = function (promise) {
            const t = {};
            return Promise.race([promise, t])
                .then(v => (v === t) ? PROMISE_STATE.PENDING : PROMISE_STATE.FULFILLED)
                .catch(() => PROMISE_STATE.REJECTED)
        };
        //返回异步函数，在then中获取状态
        Promise.prototype.getStatus = function () {
            return Promise.getStatus(this);
            //return await Promise.getStatus(that);
        };
        //如果异步函数处于pending状态，则执行函数
        Promise.ifPendingThen = function (pe, fun) {
            const t = {};
            let cpe = Promise.race([pe, t])
                .then(v => (v === t) ? Promise.resolve(PROMISE_STATE.PENDING) : Promise.reject(PROMISE_STATE.FULFILLED));
            if (fun && typeof fun === 'function') {
                return cpe.then(fun);
            }
            return cpe;
        };
        //如果异步函数处于pending状态，则执行函数
        Promise.prototype.ifPendingThen = function (fun) {
            const t = {};
            return Promise.race([this, t])
                .then(v => (v === t) ? Promise.resolve(PROMISE_STATE.PENDING) : Promise.reject(PROMISE_STATE.FULFILLED))
                .then(fun);
        };
        //必执行
        Promise.prototype.finally = Promise.prototype.finally || function (callback) {
            callback = callback || console.log;
            this.then(callback, callback);
            return this;
        };
        //延迟执行的promise
        Promise.delay = function (callTimeInterval) {
            callTimeInterval = callTimeInterval || 0;
            if (!isNaN(callTimeInterval) && callTimeInterval > 0) {
                return new Promise(resolve => setTimeout(resolve, callTimeInterval));
            } else {
                return Promise.resolve();
            }
        };
        Promise.prototype.delay = function (callTimeInterval) {
            var that = this, fun = function () {
                return Promise.delay(callTimeInterval).then(() => that);
            };
            return that.then(fun, fun);
        };
        //成功则返回延迟执行的promise
        Promise.prototype.thenDelay = function (callTimeInterval) {
            var that = this, fun = function () {
                return Promise.delay(callTimeInterval).then(() => that);
            };
            return that.then(fun);
        };
        Vue.prototype.delay = callTimeInterval => {
            return Promise.delay(callTimeInterval);
            //return new Promise(resolve => setTimeout(resolve, callTimeInterval || 0));
        };
        //依次执行数组函数(第二函数的参数为第一个函数的结果)
        Promise.allThen = (arr, callTimeInterval) => {
            return (arr || []).reduce((promiseChain, currentFunction, curIndex) => {
                    return promiseChain.delay(curIndex?callTimeInterval:0).then(currentFunction);
                },Promise.resolve(true));
        };
        //依次执行数组函数(所有函数的结果收集为一个数组)
        Promise.reduceThenByArray = (arr, callTimeInterval) => {
            return Promise.reduceThen(arr, (arr1, arr2) => arr1.concat(arr2), [], callTimeInterval);
        };
        //// reducer 是累加器函数， initialValue是初始值
        Promise.reduceThen = (arr, reducer, initialValue, callTimeInterval) => {
            reducer = reducer || console.log;
            initialValue = initialValue || [];
            var reducerHaddle = function () {
                    let result = [].splice.call(arguments, 0);
                    initialValue = reducer(initialValue, result);
                };
            return (arr || []).reduce(
                (promiseChain, currentFunction, curIndex) => {
                    if (!curIndex) {
                        promiseChain.then(reducerHaddle);
                    }
                    return promiseChain.thenDelay(callTimeInterval).then(currentFunction);
                },
                Promise.resolve(true)
            ).then(reducerHaddle)
                .then(() => initialValue);
        };
        //调用Api后自动处理结果通知
        Promise.prototype.msg = function () {
            var that = this,
                vueObj = Vue.prototype;
            that.then(vueObj.$msg.success, vueObj.$msg.fail);
            return that;
        };
        //依次执行数组函数(所有函数的结果收集为一个数组)
        Promise.reduceFinallyByArray = (arr, callTimeInterval) => {
            return Promise.reduceFinally(arr, (arr1, arr2) => arr1.concat(arr2), (arr1, arr2) => arr1.concat(arr2), [], [], callTimeInterval);
        };
        //// reducer 是累加器函数, failReducer 为失败累加器， initialValue是成功初始值， failInitialValue是成功初始值
        Promise.reduceFinally = (arr, reducer, failReducer, initialValue, failInitialValue, callTimeInterval) => {
            reducer = reducer || console.log;
            initialValue = initialValue || [];
            failReducer = failReducer || console.log;
            failInitialValue = initialValue || [];
            var reducerHaddle = function () {
                    let result = [].splice.call(arguments, 0);
                    initialValue = reducer(initialValue, result);
                },
                reducerFailHaddle = function () {
                    let result = [].splice.call(arguments, 0);
                    failInitialValue = failReducer(failInitialValue, result);
                };
            return (arr || []).reduce(
                (promiseChain, currentFunction, curIndex) => {
                    if (!curIndex) {
                        promiseChain.then(reducerHaddle, reducerFailHaddle);
                    }
                    return promiseChain.delay(callTimeInterval).then(currentFunction, currentFunction);
                },
                Promise.resolve(true)
            ).then(reducerHaddle, reducerFailHaddle)
                .then(() => [initialValue, failInitialValue]);
        };

        //#endregion

        //#region -----调用缓存--刷新整个页面，缓存消失
        var loadCacheObj = {};
        Vue.prototype.loadPe = function (key, fun) {
            return Vue.prototype.loadCache(key, fun, -1);
        };
        Vue.prototype.loadGlobal = function (key, fun) {
            return Vue.prototype.loadCache(key, fun, "");
        };
        /**
         * 调用加上缓存，指定时间只调用第一次
         * @param {*} key
         * @param {*} fun
         * @param {*} time 如果为-1，则在请求结束后删除缓存,如果为空，则一直缓存到刷新整个页面
         * @returns
         */
        Vue.prototype.loadCache = function (key, fun, time) {
            //初始化参数
            if (key) {
                if (typeof (key) == "function") {
                    fun = key;
                    key = this.getPageKey("_loadCache");
                } else if (typeof (key) != "string") {
                    key = JSON.stringify(key);
                }
            } else {
                key = this.getPageKey("_loadCache");
            }
            if (fun) {
                if(!Promise.isPromise(fun)){
                    if (typeof (fun) !== "function") {
                        fun = () => Promise.resolve(fun);
                    }
                }
            } else {
                fun = () => Promise.reject(null);
            }
            if (!loadCacheObj[key]) {
                loadCacheObj[key] = Promise.resolve(fun());
            }
            //指定时间删除缓存
            if (time) {
                let delFun = () => {
                    loadCacheObj[key] = null;
                };
                if (time > 0) {
                    setTimeout(delFun, time);
                } else {
                    loadCacheObj[key].finally(delFun);
                }
            }
            return loadCacheObj[key];
        };
        //#endregion

        //#region -----调用Api相关
        //#endregion

        //#region -----导出相关
        /**
         * 获取所有页面数据(Boss后台专用)(其它后台要用需要改一下所有页加载完成的判断条件)
         * @param {*} noticeFun 通知函数，可以为null
         * @param {*} callTimeInterval 调用间隔
         * @param {*} method 方法
         * @param {*} params 参数
         * @param {*} pageNum 页码 默认1
         * @param {*} pageSize 每页条数 默认15
         * @param {*} pageNumName 页码参数名 默认pageNum
         * @param {*} pageSizeName 每页条数参数名 默认pageSize
         * @returns
         */
        //  下面是AI翻译：
        //  这段代码定义了一个 Vue.js 原型方法 getAllPageData，用于获取分页数据。参数说明如下：
        //  noticeFun：通知函数，可以自定义函数或使用 console.log 打印通知信息。
        //  callTimeInterval：调用时间间隔，表示每次请求之间的延迟时间，以避免过快地发起请求。
        //  method：异步请求方法，用于获取分页数据，该方法应返回一个 Promise 对象。
        //  params：请求参数，一个对象，用于传递额外的请求参数。
        //  pageNum：当前页码，默认为 1。
        //  pageSize：每页数据量，默认为 15。
        //  pageNumName：页码参数名称，默认为 "pageNum"。
        //  pageSizeName：每页数据量参数名称，默认为 "pageSize"。
        //  在函数内部，首先对参数进行了一些默认值处理。然后定义了一个 nextPage 函数，该函数用于获取下一页的数据。它通过调用传入的 method 方法发起异步请求，并将返回的数据存储到 tableData 数组中。如果满足停止加载条件（达到最后一页、没有下一页或当前页数据为空），则返回 tableData。否则，根据设定的时间间隔延迟一段时间后再次调用 nextPage 函数获取下一页数据。

        //  最后，通过调用 nextPage(pageNum) 来开始获取数据，并返回一个 Promise 对象。使用者可以通过 .then() 方法处理异步操作的结果。
        Vue.prototype.getAllPageData = (noticeFun, callTimeInterval, method, params, pageNum, pageSize, pageNumName, pageSizeName) => {
            noticeFun = noticeFun || console.log;
            pageNumName = pageNumName || "pageNum";
            pageSizeName = pageSizeName || "pageSize";

            var that = Vue.prototype,
                args = Object.assign({}, params || {}, { pageNumName: pageNum || 1, pageSizeName: pageSize || 15 }),
                tableData = [];
            const nextPage = curPageNum => {
                noticeFun(`开始加载第${curPageNum}页数据`);
                args[pageNumName] = curPageNum;
                return method(args).then(res => {
                    var data = (res || {}).data || {},
                        records = data.list || [];
                    tableData.push.apply(tableData, records);
                    noticeFun(`第${curPageNum}页数据加载完成`);
                    if (data.pages == data.pageNum || !data.hasNextPage || records.length == 0) {
                        return tableData;
                    }
                    return that.delay(callTimeInterval).then(() => nextPage(curPageNum + 1));
                })
            };
            return nextPage(pageNum);
        };
        Vue.prototype.getAllPageDataFun = (method, params, pageNum, pageSize) => {
            return Vue.prototype.getAllPageData(console.log, 0, method, params, pageNum, pageSize);
        };
        //#endregion

        //#region 工具方法
        /////---获取当日
        Vue.prototype.nowStr = () => {
            let date = new Date();
            let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            return date.getFullYear() + "-" + month + "-" + day;
        }
        /////---获取当前时间
        Vue.prototype.nowTimeStr = function () {
            return (this || Vue.prototype).$moment().format('YYYY-MM-DD HH:mm:ss');
        }
        /////---获取时间字符串
		Vue.prototype.nowTimeNumStr = function () {
			return (this || Vue.prototype).$moment().format('YYYYMMDDHHmmss');
		};


        //#endregion

        //#region 共用方法
        //#endregion

        //#region 公共挂截实例

        //挂截excelUtil
        Vue.prototype.excelUtil = excelUtil;
        //#endregion

        //#region 浏览器相关
        Vue.prototype.changeFavicon = link => {
            let $favicon = document.querySelector('link[rel="icon"]');
            if ($favicon !== null) {
                $favicon.href = link;
            } else {
                $favicon = document.createElement("link");
                $favicon.rel = "icon";
                $favicon.href = link;
                document.head.appendChild($favicon);
            }
        };
        Vue.prototype.changeTitle = function (title) {
            document.title = title;
        };
        //#endregion

    }
}

